// extracted by css-extract-rspack-plugin
export default {"drawerHeader":"AccountPermissionsDrawer_drawerHeader__Xk-Mn"};